import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import EBasicActions from '@/enums/EBasicActions';
import { PrivateRoute } from '@/hooks/useAuth';

const InvoicePage = lazy(() => import('@/containers/Views/Invoice/InvoicePage'));
const CreateInvoicePage = lazy(() => import('@/containers/Views/Invoice/CreateInvoicePage'));
const InvoiceDetailPage = lazy(() => import('@/containers/Views/Invoice/InvoiceDetailPage'));

const InvoiceRouter = (
  <Route path="invoices">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.Invoices} 
          permissions={EBasicActions.Find}
        >
          <InvoicePage />
        </PrivateRoute>
      )} 
    />
    <Route 
      path="new" 
      element={(
        <PrivateRoute 
          pageName={EPage.Invoices} 
          permissions={EBasicActions.Create}
        >
          <CreateInvoicePage />
        </PrivateRoute>
      )}
    />
    <Route 
      path=":invoiceId" 
      element={(
        <PrivateRoute 
          pageName={EPage.Invoices} 
          permissions={EBasicActions.Find}
        >
          <InvoiceDetailPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default InvoiceRouter;
